import React from 'react';

import AdminChannelImportPage from '../../screens/AdminChannelImportPage/AdminChannelImportPage.component';

const AdminChannelImport: React.FC = () => <AdminChannelImportPage />;

export default AdminChannelImport;
